import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";
import PDFViewerImage47 from "../../../../assets/PDFViewerImages/PDFViewerImage47.jpg";
import PDFViewerImage48 from "../../../../assets/PDFViewerImages/PDFViewerImage48.jpg";
import PDFViewerImage49 from "../../../../assets/PDFViewerImages/PDFViewerImage49.jpg";
import PDFViewerImage50 from "../../../../assets/PDFViewerImages/PDFViewerImage50.jpg";
import PDFViewerImage51 from "../../../../assets/PDFViewerImages/PDFViewerImage51.jpg";
import PDFViewerImage52 from "../../../../assets/PDFViewerImages/PDFViewerImage52.jpg";
import PDFViewerImage53 from "../../../../assets/PDFViewerImages/PDFViewerImage53.jpg";
import PDFViewerImage54 from "../../../../assets/PDFViewerImages/PDFViewerImage54.jpg";
import PDFViewerImage55 from "../../../../assets/PDFViewerImages/PDFViewerImage55.jpg";
import PDFViewerImage56 from "../../../../assets/PDFViewerImages/PDFViewerImage56.jpg";
import PDFViewerImage57 from "../../../../assets/PDFViewerImages/PDFViewerImage57.jpg";
import PDFViewerImage58 from "../../../../assets/PDFViewerImages/PDFViewerImage58.jpg";
import PDFViewerImage59 from "../../../../assets/PDFViewerImages/PDFViewerImage59.jpg";
import PDFViewerImage60 from "../../../../assets/PDFViewerImages/PDFViewerImage60.jpg";
import PDFViewerImage61 from "../../../../assets/PDFViewerImages/PDFViewerImage61.jpg";
import PDFViewerImage62 from "../../../../assets/PDFViewerImages/PDFViewerImage62.jpg";
import PDFViewerImage63 from "../../../../assets/PDFViewerImages/PDFViewerImage63.jpg";
import PDFViewerImage64 from "../../../../assets/PDFViewerImages/PDFViewerImage64.jpg";
import PDFViewerImage65 from "../../../../assets/PDFViewerImages/PDFViewerImage65.jpg";
import PDFViewerImage66 from "../../../../assets/PDFViewerImages/PDFViewerImage66.jpg";
import PDFViewerImage67 from "../../../../assets/PDFViewerImages/PDFViewerImage67.jpg";
import PDFViewerImage68 from "../../../../assets/PDFViewerImages/PDFViewerImage68.jpg";
import PDFViewerImage69 from "../../../../assets/PDFViewerImages/PDFViewerImage69.jpg";
import PDFViewerImage70 from "../../../../assets/PDFViewerImages/PDFViewerImage70.jpg";
import PDFViewerImage71 from "../../../../assets/PDFViewerImages/PDFViewerImage71.jpg";
import PDFViewerImage72 from "../../../../assets/PDFViewerImages/PDFViewerImage72.jpg";
import PDFViewerImage73 from "../../../../assets/PDFViewerImages/PDFViewerImage73.jpg";


const Chapter22 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);

    return (
        <>
                 {/* Chapter 22 */}
                <section id="section22" className="drivers-handbook-section">
                    <h2 className="drivers-handbook-heading">{language.chapter22Title}</h2>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph1}
                    </p>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22List11}</li>
                        <li>{language.chapter22List12}</li>

                    </ul>

                    <h3 className="drivers-handbook-subheading">{language.chapter22Subheading1}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22List21}</li>
                        <li>{language.chapter22List22}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter22List31}</li>
                            <li>{language.chapter22List32}</li>
                            <li>{language.chapter22List33}</li>
                            <li>{language.chapter22List34}</li>
                        </ul>
                        <li>{language.chapter22List23}</li>
                        <ul className="drivers-handbook-list">
                            <li>{language.chapter22List231}</li>
                            <li>{language.chapter22List232}</li>
                            <li>{language.chapter22List233}</li>
                        </ul>
                        <li>{language.chapter22List24}</li>
                    </ul>
                    <h3 className="drivers-handbook-subheading">{language.chapter22Subheading3}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage47} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage48} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage49} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage50} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage51} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage52} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter22Subheading21}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22Subheading4}</li>

                        <div className="image-box">
                            <img src={PDFViewerImage53} alt="Traffic Rules"/>
                        </div>

                        <div className="image-box">
                            <img src={PDFViewerImage54} alt="Traffic Rules"/>
                        </div>

                        <div className="image-box">
                            <img src={PDFViewerImage55} alt="Traffic Rules"/>
                        </div>


                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph2}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage56} alt="Traffic Rules"/>
                    </div>

                    <p className="drivers-handbook-paragraph">
                       {language.chapter22Paragraph3}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph4}
                    </p>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph5}

                    </p>
                    <div className="image-box">
                        <img src={PDFViewerImage57} alt="Traffic Rules"/>
                    </div>
                    <div className="image-box">
                        <img src={PDFViewerImage58} alt="Traffic Rules"/>
                    </div>

                    <ul className="drivers-handbook-list">
                        <li> {language.chapter22Subheading5}</li>
                    </ul>

                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph6}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage59} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22Subheading6}</li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage60} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22Subheading7}</li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage61} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22Subheading8}</li>
                    </ul>
                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph7}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage62} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph8}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage63} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph9}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage64} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Paragraph10}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage65} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage66} alt="Traffic Rules"/>
                    </div>


                    <h3 className="drivers-handbook-subheading">{language.chapter22Subheading9}</h3>
                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22List41}</li>
                        
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage67} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Subheading12}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage68} alt="Traffic Rules"/>
                    </div>


                    <p className="drivers-handbook-paragraph">
                        {language.chapter22Subheading11}
                    </p>

                    <div className="image-box">
                        <img src={PDFViewerImage69} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage70} alt="Traffic Rules"/>
                    </div>


                    <ul className="drivers-handbook-list">
                        <li>{language.chapter22Subheading9}</li>
                    </ul>

                    <div className="image-box">
                        <img src={PDFViewerImage71} alt="Traffic Rules"/>
                    </div>

                    <h3 className="drivers-handbook-subheading">{language.chapter22Subheading10}</h3>

                    <div className="image-box">
                        <img src={PDFViewerImage72} alt="Traffic Rules"/>
                    </div>

                    <div className="image-box">
                        <img src={PDFViewerImage73} alt="Traffic Rules"/>
                    </div>


                </section>
        </>
    )

}

export default Chapter22;
